import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "default-content" }
const _hoisted_3 = { class: "collapse-content" }
const _hoisted_4 = { class: "collapse-content" }
const _hoisted_5 = { class: "edit-form" }
const _hoisted_6 = { class: "collapse-content" }
const _hoisted_7 = { class: "collapse-content" }
const _hoisted_8 = { class: "collapse-content" }
const _hoisted_9 = { class: "collapse-content" }
const _hoisted_10 = { class: "new-form" }

export function render(_ctx, _cache) {
  const _component_Header = _resolveComponent("Header")
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")
  const _component_List = _resolveComponent("List")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")
  const _component_Briefcase = _resolveComponent("Briefcase")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_Check = _resolveComponent("Check")
  const _component_Delete = _resolveComponent("Delete")
  const _component_el_table = _resolveComponent("el-table")
  const _component_CirclePlusFilled = _resolveComponent("CirclePlusFilled")
  const _component_el_collapse = _resolveComponent("el-collapse")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["windowWidth", "windowHeight"]),
    _createVNode(_component_Navigation, {
      activeMenu: _ctx.NavigationIndex.CUSTOMER,
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["activeMenu", "windowWidth", "windowHeight"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createElementVNode("div", { class: "danger" }, [
                  _createElementVNode("h4", null, "Zugang verweigert."),
                  _createElementVNode("p", null, "Sie besitzen nicht die erforderliche Berechtigung für diesen Bereich.")
                ], -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, !_ctx.hasPermission['CUST_UPDATE'] && !_ctx.loading]
        ]),
        (_ctx.customerModel && _ctx.locationModel && _ctx.hasPermission['CUST_UPDATE'])
          ? (_openBlock(), _createBlock(_component_Breadcrumbs, {
              key: 0,
              breadcrumbs: [['Mandanten', '/customer'], [_ctx.customerModel.name, '/customer/'+_ctx.customerModel.customerid], ['Standorte'], [_ctx.locationModel.name]]
            }, null, 8, ["breadcrumbs"]))
          : _createCommentVNode("", true),
        (_ctx.hasPermission['CUST_UPDATE'])
          ? (_openBlock(), _createBlock(_component_el_container, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_main, { class: "rounded-content" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_collapse, {
                      modelValue: _ctx.activeName,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.activeName) = $event)),
                      accordion: "",
                      ref: "coll"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_collapse_item, { name: "1" }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              _createVNode(_component_el_icon, { size: 32 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_List)
                                ]),
                                _: 1
                              })
                            ]),
                            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "title-label" }, "Stammdaten", -1))
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createElementVNode("div", _hoisted_5, [
                                _createVNode(_component_el_form, {
                                  ref: "editLocationForm",
                                  rules: _ctx.rules,
                                  "label-position": "top",
                                  model: _ctx.locationModel,
                                  "label-width": "120px"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, {
                                      label: "Name",
                                      prop: "name"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.locationModel.name,
                                          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.locationModel.name) = $event)),
                                          onInput: _ctx.onLocationInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Beschreibung",
                                      prop: "description"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.locationModel.description,
                                          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.locationModel.description) = $event)),
                                          onInput: _ctx.onLocationInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Strasse",
                                      prop: "street"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.locationModel.street,
                                          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.locationModel.street) = $event)),
                                          onInput: _ctx.onLocationInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Postleitzahl",
                                      prop: "zipcode"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.locationModel.zipcode,
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.locationModel.zipcode) = $event)),
                                          onInput: _ctx.onLocationInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Ort",
                                      prop: "city"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.locationModel.city,
                                          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.locationModel.city) = $event)),
                                          onInput: _ctx.onLocationInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Region",
                                      prop: "region"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.locationModel.region,
                                          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.locationModel.region) = $event)),
                                          onInput: _ctx.onLocationInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Land",
                                      prop: "country"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.locationModel.country,
                                          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.locationModel.country) = $event)),
                                          onInput: _ctx.onLocationInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_button, {
                                          type: "primary",
                                          disabled: !_ctx.formLocationValid,
                                          onClick: _ctx.onLocationSaveClick
                                        }, {
                                          default: _withCtx(() => _cache[12] || (_cache[12] = [
                                            _createTextVNode(" Speichern ")
                                          ])),
                                          _: 1
                                        }, 8, ["disabled", "onClick"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["rules", "model"])
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_collapse_item, { name: "2" }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              _createVNode(_component_el_icon, { size: 32 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Briefcase)
                                ]),
                                _: 1
                              })
                            ]),
                            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "title-label" }, "Abteilungen", -1))
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, [
                              _withDirectives((_openBlock(), _createBlock(_component_el_table, { data: _ctx.departmentModelList }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_table_column, {
                                    prop: "departmentid",
                                    label: "ID",
                                    width: "80"
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "name",
                                    label: "Bezeichnung",
                                    width: "300"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.departmentModelList[scope.$index].name,
                                        "onUpdate:modelValue": $event => ((_ctx.departmentModelList[scope.$index].name) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "description",
                                    label: "Beschreibung"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.departmentModelList[scope.$index].description,
                                        "onUpdate:modelValue": $event => ((_ctx.departmentModelList[scope.$index].description) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "dateupdate",
                                    label: "Letzte Änderung",
                                    width: "200"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createTextVNode(_toDisplayString(new Intl.DateTimeFormat('de-DE', {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'}).format(new Date(0).setUTCSeconds(_ctx.departmentModelList[scope.$index].dateupdate))), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    fixed: "right",
                                    label: "",
                                    width: "60"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createVNode(_component_el_button, {
                                        type: "success",
                                        onClick: $event => (_ctx.onDepartmentSaveClick(_ctx.departmentModelList[scope.$index])),
                                        circle: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, { size: 16 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Check)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    fixed: "right",
                                    label: "",
                                    width: "60"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createVNode(_component_el_button, {
                                        type: "danger",
                                        onClick: $event => (_ctx.onDepartmentDeleteClick(_ctx.departmentModelList[scope.$index])),
                                        circle: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, { size: 16 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Delete)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["data"])), [
                                [_directive_loading, _ctx.loading]
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_collapse_item, { name: "3" }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, [
                              _createVNode(_component_el_icon, { size: 32 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_CirclePlusFilled)
                                ]),
                                _: 1
                              })
                            ]),
                            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "title-label" }, "Neue Abteilung", -1))
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _createVNode(_component_el_form, {
                                  ref: "newDepartmentForm",
                                  rules: _ctx.rules,
                                  "label-position": "top",
                                  model: _ctx.newDepartmentModel,
                                  "label-width": "120px"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, {
                                      label: "Name",
                                      prop: "name"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.newDepartmentModel.name,
                                          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.newDepartmentModel.name) = $event)),
                                          onInput: _ctx.onDepartmentInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Beschreibung",
                                      prop: "description"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.newDepartmentModel.description,
                                          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.newDepartmentModel.description) = $event)),
                                          onInput: _ctx.onDepartmentInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_button, {
                                          type: "primary",
                                          disabled: !_ctx.formDepartmentValid,
                                          onClick: _ctx.onNewDepartmentClick
                                        }, {
                                          default: _withCtx(() => _cache[15] || (_cache[15] = [
                                            _createTextVNode("Hinzufügen ")
                                          ])),
                                          _: 1
                                        }, 8, ["disabled", "onClick"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["rules", "model"])
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}